import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { getAuthToken, isTokenExpired, getUserType, logout } from "../../utility/auth";
import "./Login.css";



export default function Login() {
    const [uname, unamechange] = useState("");
    const [pass, passchange] = useState("");
    const [keepLoggedIn, setKeepLoggedIn] = useState(false); // State for "Keep Me Logged In"
    const navigate = useNavigate();
const handleSubmit = (e) => {
  e.preventDefault();
  const empdata = { uname, pass };

  axios.post("/login", empdata)
    .then((res) => {
      if (res.status === 200) {
        const data = res.data;
        if (data.token) {
          const token = data.token;
          const usertype = data.data.type.toLowerCase(); // Normalize to lowercase
          const expirationTime = Date.now() + 3 * 60 * 60 * 1000; // 3 hours

          if (keepLoggedIn) {
            localStorage.setItem("token", token);
            localStorage.setItem("expirationTime", expirationTime);
            localStorage.setItem("uname", data.data.uname);
            localStorage.setItem("usertype", usertype); // Store normalized usertype
          } else {
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("expirationTime", expirationTime);
            sessionStorage.setItem("uname", data.data.uname);
            sessionStorage.setItem("usertype", usertype); // Store normalized usertype
          }

          toast.success("Logged in Successfully");

          // Add delay before redirect
          setTimeout(() => {
            console.log("Redirecting user with type:", usertype); // Debug log
            if (usertype === "admin") {
              navigate("/dashboard/analytics", { replace: true });
            } else if (usertype === "account") {
              navigate("/dashboard/account", { replace: true });
            } else if (usertype === "cashier") {
              navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
            } else if (usertype === "manager") {
              navigate("/dashboard/analytics", { replace: true }); // Redirect managers to analytics dashboard
            } else {
              console.warn("Unknown user type:", usertype);
              navigate("/dashboard/analytics", { replace: true }); // Default fallback to admin dashboard
            }
          }, 1000); // Increased delay

        } else {
          toast.error("Invalid Token Received");
        }
      } else if (res.status === 401) {
        toast.error("Wrong username/Password");
      }
    })
    .catch((err) => {
      toast.error("Wrong username/Password");
      console.log(err.message);
    });
};
useEffect(() => {
  const token = getAuthToken();
  const userType = getUserType();
  console.log("Token:", token);
  console.log("Is expired:", isTokenExpired());
  console.log("User type:", userType);

  if (token && !isTokenExpired()) {
    const normalizedUserType = userType?.toLowerCase();
    console.log("Normalized user type:", normalizedUserType);
    
    switch (normalizedUserType) {
      case "admin":
        navigate("/dashboard/admin", { replace: true });
        break;
      case "account":
        navigate("/dashboard/account", { replace: true });
        break;
      case "cashier":
        navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
        break;
      case "manager":
        navigate("/dashboard/admin", { replace: true }); // Redirect managers to admin dashboard
        break;
      default:
        console.warn("Unknown user type, staying on login");
        logout(); // Clear invalid session
        break;
    }
  }
}, [navigate]);

    return (
        <>
            <ToastContainer />
            <div className="login-page">
                {/* Animated Background Elements */}
                <div className="animated-background" />
                
                <div className="login-container">
                    {/* Left Column - Login Form */}
                    <div className="login-form-section">
                        {/* Header Section */}
                        <div className="form-header">
                            <div className="logo-container">
                                <i className="fas fa-store logo-icon"></i>
                            </div>
                            <h1 className="brand-title">StoreHub</h1>
                            <p className="brand-subtitle">Retail Management System</p>
                            <div className="brand-underline"></div>
                        </div>

                        <form className="login-form" onSubmit={handleSubmit}>
                            {/* Username Field */}
                            <div className="form-group">
                                <label className="form-label">Username</label>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        className="form-input"
                                        required
                                        id="uname"
                                        value={uname}
                                        onChange={(e) => unamechange(e.target.value)}
                                        placeholder="Enter your username"
                                    />
                                    <div className="input-icon">
                                        <i className="fas fa-user"></i>
                                    </div>
                                </div>
                            </div>

                            {/* Password Field */}
                            <div className="form-group">
                                <div className="password-header">
                                    <label className="form-label">Password</label>
                                    <Link to="/forgot-password" className="forgot-password-link">
                                        Forgot password?
                                    </Link>
                                </div>
                                <div className="input-container">
                                    <input
                                        type="password"
                                        className="form-input"
                                        required
                                        id="pass"
                                        value={pass}
                                        onChange={(e) => passchange(e.target.value)}
                                        placeholder="Enter your password"
                                    />
                                    <div className="input-icon">
                                        <i className="fas fa-lock"></i>
                                    </div>
                                </div>
                            </div>

                            {/* Keep Me Logged In */}
                            <div className="form-group checkbox">
                                <label className="checkbox-container">
                                    <div className="checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            className="form-checkbox"
                                            checked={keepLoggedIn}
                                            onChange={() => setKeepLoggedIn(!keepLoggedIn)}
                                        />
                                    </div>
                                    Keep me logged in
                                </label>
                            </div>

                            {/* Submit Button */}
                            <button type="submit" className="submit-button">
                                <i className="fas fa-sign-in-alt button-icon"></i>
                                Sign In to StoreHub
                            </button>
                        </form>
                    </div>

                    {/* Right Column - Feature Showcase */}
                    <div className="feature-section">
                        {/* Decorative Background */}
                        <div className="feature-background" />
                        
                        <div className="feature-content">
                            <div className="welcome-header">
                                <h2 className="welcome-title">
                                    Welcome to StoreHub
                                </h2>
                                <p className="welcome-subtitle">
                                    Your complete retail management solution
                                </p>
                            </div>
                            
                            <div className="features-list">
                                <div className="feature-item">
                                    <div className="feature-icon analytics">
                                        <i className="fas fa-chart-bar"></i>
                                    </div>
                                    <div className="feature-text">
                                        <h4 className="feature-title">Sales Analytics</h4>
                                        <p className="feature-description">
                                            Real-time sales tracking and detailed analytics
                                        </p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon inventory">
                                        <i className="fas fa-boxes"></i>
                                    </div>
                                    <div className="feature-text">
                                        <h4 className="feature-title">Inventory Management</h4>
                                        <p className="feature-description">
                                            Smart stock control and automated reordering
                                        </p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon pos">
                                        <i className="fas fa-cash-register"></i>
                                    </div>
                                    <div className="feature-text">
                                        <h4 className="feature-title">Point of Sale</h4>
                                        <p className="feature-description">
                                            Fast and efficient checkout process
                                        </p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon staff">
                                        <i className="fas fa-users-cog"></i>
                                    </div>
                                    <div className="feature-text">
                                        <h4 className="feature-title">Staff Management</h4>
                                        <p className="feature-description">
                                            Employee scheduling and performance tracking
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
